import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { GallerySubCommunityRoutes } from '../../../routes/HomeRoutes/GallerySubCommunityRoutes';

export const GallerySubCommunityLayout = () => <SwitchRoute routes={GallerySubCommunityRoutes} />;
